import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReportsComponent } from './reports.component';
import { CoreModule } from 'src/app/core/core.module';
import { ReportsRoutingModule } from './reports-routing.module';
import { RequetsModule } from '../requets/requets.module';
import { SearchFieldsReportsComponent } from './search-fields-reports/search-fields-reports.component';
import { RequestsEvaluatedComponent } from './requests-evaluated/requests-evaluated.component';
import { ViewRequestsComponent } from './view-requests/view-requests.component';
import { RequestsStudentComponent } from './requests-student/requests-student.component';
import { RequestsStudentDialogComponent } from 'src/app/core/modal/requests-student-dialog/requests-student-dialog.component';
import { ViewTestComponent } from './view-test/view-test.component';
import { StateRequestsComponent } from './state-requests/state-requests.component';
import { SearchFieldsStateComponent } from './search-fields-state/search-fields-state.component';
import { ContentStateRequestsComponent } from './content-state-requests/content-state-requests.component';
import { SearchFieldsTestComponent } from './search-fields-test/search-fields-test.component';
import { ViewTestRequestsComponent } from './view-test-requests/view-test-requests.component';
import { StateTestComponent } from './state-test/state-test.component';
import { RequestsRecognitionComponent } from './requests-recognition/requests-recognition.component';
import { ViewRequestsRecognitionComponent } from './view-requests-recognition/view-requests-recognition.component';
import { ViewRequestsDelayComponent } from './view-requests-delay/view-requests-delay.component';
import { ViewRequestsDenyComponent } from './view-requests-deny/view-requests-deny.component';
import { ViewRequestsAcceptedComponent } from './view-requests-accepted/view-requests-accepted.component';
import { ViewRequestsAssignedComponent } from './view-requests-assigned/view-requests-assigned.component';
import { SearchFieldsRequestsComponent } from './search-fields-requests/search-fields-requests.component';
import { ViewTestStudentComponent } from './view-test-student/view-test-student.component';

@NgModule({
  imports: [
    CoreModule,
    ReportsRoutingModule,
    RequetsModule
  ],
  declarations: [ReportsComponent, SearchFieldsReportsComponent, RequestsEvaluatedComponent,
    ViewRequestsComponent, RequestsStudentComponent, RequestsStudentDialogComponent, ViewTestComponent
    , SearchFieldsStateComponent,  ContentStateRequestsComponent , StateRequestsComponent,
    SearchFieldsTestComponent, ViewTestRequestsComponent, StateTestComponent, RequestsRecognitionComponent,
    ViewRequestsRecognitionComponent,
    ViewRequestsDelayComponent,
    ViewRequestsDenyComponent,
    ViewRequestsAcceptedComponent,
    ViewRequestsAssignedComponent,
    SearchFieldsRequestsComponent,
    ViewTestStudentComponent],
  exports: [RequetsModule, SearchFieldsReportsComponent, RequestsEvaluatedComponent,
    ReportsComponent, ViewRequestsComponent, RequestsStudentComponent, RequestsStudentDialogComponent, ViewTestComponent,
    StateRequestsComponent, SearchFieldsStateComponent, ContentStateRequestsComponent,
    SearchFieldsTestComponent, ViewTestRequestsComponent, StateTestComponent, RequestsRecognitionComponent,
    ViewRequestsRecognitionComponent,
    ViewRequestsDelayComponent,
    ViewRequestsDenyComponent,
    ViewRequestsAcceptedComponent,
    ViewRequestsAssignedComponent,
    SearchFieldsRequestsComponent,
    ViewTestStudentComponent],
    entryComponents: [RequestsStudentDialogComponent]

})
export class ReportsModule { }
